import React from 'react';
import PropTypes from 'prop-types';
import { Virtuoso } from 'react-virtuoso';
import { Box, Flex } from 'rebass/styled-components';
import { Loader } from '@getro/rombo';

import { Card } from '../boardCard';

export const CardList = ({ column, CardComponent, disableVerticalDragging, isFetching, onEndReached }) => (
  <Box
    as={Virtuoso}
    flex="1"
    height="100%"
    data={column.cards}
    useWindowScroll={false}
    style={{ height: '100%', minHeight: 'calc(100vh - 180px)' }}
    itemContent={(_index, card) => (
      <Card
        card={card}
        columnId={column.id}
        CardComponent={CardComponent}
        disableVerticalDragging={disableVerticalDragging}
      />
    )}
    endReached={() => onEndReached(column)}
    computeItemKey={(_index, item) => item?.id}
    increaseViewportBy={{ top: 600, bottom: 800 }}
    components={{
      // eslint-disable-next-line react/no-multi-comp
      Footer: () =>
        isFetching ? (
          <Flex justifyContent="center" pb="16px" pt="8px">
            <Loader size="small" />
          </Flex>
        ) : null,
    }}
  />
);

CardList.propTypes = {
  column: PropTypes.object.isRequired,
  CardComponent: PropTypes.func.isRequired,
  disableVerticalDragging: PropTypes.bool,
  onEndReached: PropTypes.func,
  isFetching: PropTypes.bool,
};

CardList.defaultProps = {
  disableVerticalDragging: false,
  onEndReached: () => {},
  isFetching: false,
};
